import { useEffect, useState } from 'react';
import { useApplicationContext } from '../../../context/ApplicationContext/ApplicationContext';
import { initializeOfflineDatabase } from '../offlineDatabase/offlineDatabase';

export const useHandleHydrateOfflineDatabase = ({
  runOnce,
  forceInitialize,
}: UseHandleHydrateOfflineDatabaseProps = {}) => {
  const { team } = useApplicationContext();
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    if (runOnce && isHydrated) {
      return;
    }

    if (team?.id || forceInitialize) {
      initializeOfflineDatabase();
      setTimeout(() => setIsHydrated(true), 100);
    }
  }, [team?.id, forceInitialize]);

  return { isHydrated };
};

interface UseHandleHydrateOfflineDatabaseProps {
  runOnce?: boolean;
  forceInitialize?: boolean;
}
